import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {CmsHtmlPage} from "../cms-html-page";
import {InfoPageService} from "../info-page.service";
import {TranslateService} from "../../shared/translate.service";
import {AuthService} from "../../auth/auth.service";

@Component({
  selector: 'app-info-page',
  templateUrl: './info-page.component.html',
  styleUrls: ['./info-page.component.scss']
})
export class InfoPageComponent implements OnInit {

  loading: boolean = false;

  isSuccess: boolean = true;

  pageName: string;

  pageContent: string;

  pageData: CmsHtmlPage;

  constructor(
    private infoPageService: InfoPageService,
    private route: ActivatedRoute,
    private router: Router,
    private translateService: TranslateService,
    private authService: AuthService) {
  }

  ngOnInit() {
    this.route.params.subscribe((params: { pageName: string }) => {
      this.pageName = params.pageName;
      this.getComponentOrRedirectToUnauth();

    });

    this.translateService.languageChanged.subscribe(() => {
      this.getComponentOrRedirectToUnauth();
    });
  }

  private getComponentOrRedirectToUnauth() {
    this.authService.isAuthServiceOnline().subscribe(() => {
      this.authService.isLogged.subscribe(loggedIn => {
        this.getComponent(loggedIn);
      }, e => {
        this.getComponent(false);
      });
    }, e => this.getComponent(false));
  }

  private getComponent(loggedIn: boolean) {
    this.loading = true;
    this.infoPageService.getComponent(this.pageName, true).subscribe(data => {
      this.pageData = data;
      this.pageContent = this.infoPageService.createPage(data);
      this.redirect(data.loggedOnly, loggedIn);
      this.isSuccess = true;
      this.loading = false;
    }, error => {
      console.log(error);
      this.isSuccess = false;
      this.loading = false;
    });
  }

  private redirect(signInRequired: boolean, isLoggedIn: boolean) {
    if (signInRequired && !isLoggedIn) {
      this.router.navigate(['/401']);
    }
  }
}
